const sortInfoNames = (a, b) => {
  let fullnameA, fullnameB;
  fullnameA = a.info.firstName + ' ' + a.info.lastName;
  fullnameB = b.info.firstName + ' ' + b.info.lastName;
  return fullnameA.localeCompare(fullnameB);
};

export default sortInfoNames;
